import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import PageLayout from "../Layouts/PageLayout";
import ProfileImg from "../Assets/Images/ProfileImg.png";
import ActiveIcon from "../Assets/Icons/activeIcon.svg";
import "../Styles/Admin.css";
import SendIcon from "../Assets/Icons/sendIcon.svg";
import { ToastContainer, toast } from "react-toastify";


export default function SendEmailMerchant() {
    const notify = () => toast.info("Sent Successfully");
  return (
    <Container fluid>
         <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <PageLayout>
        <div>
          <div className="merchant-email-heading-con">
            <img src={ProfileImg} />
            <div className="merchant-email-heading">
              <h4>Merchant Name</h4>
              <div className="merchant-active-status">
                <img src={ActiveIcon} />
                <h5>Active</h5>
              </div>
            </div>
          </div>
          <div className="send-email-merchant-con">
            <h1>Send mail</h1>
            <Card className="send-email-card">
              <div className="merchant-card-header">
                <img src={SendIcon} />
                <h4>Email to</h4>
                <h5>merchant@email.com</h5>
              </div>
              <div className="merchant-card-input">
                <div className="merchant-card-input-con">
                  <p>From</p>
                  <input type="text" placeholder="admin@admin.com" />
                </div>
                <div className="merchant-card-input-con">
                  <p>Subject</p>
                  <input type="text" placeholder="admin@admin.com" />
                </div>
                <div className="merchant-text-area">
                    <textarea placeholder="Your Email ...."></textarea>
                </div>
                <div className="send-email-btn">
                <Button onClick={notify} variant='primary'>Send email</Button>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </PageLayout>
    </Container>
  );
}
